export default __webpack_public_path__ + "static/media/phone.e4461702.png";